// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3a-1";
export var movingGradient = "_3a-4";
export var movingGradientBlock = "_3a-2";
export var skeleton = "_3a-0";
export var skeletonText = "_3a-3";